import PageReady from './behaviours/page-ready'
import LinkTile from './behaviours/link-tile'
import MobileMenu from './components/mobile-menu'
import ToTopButton from './components/to-top-button'
import AutocompleteField from './components/search/autocomplete'
import SearchField from './components/search/search-field'
import Carousel from './components/carousel'
import PopUp from './components/pop-up'
import EmbeddedVideo from './components/embedded-video'
import Map from './components/map'
import ShowMapButton from './components/show-map-button/index.js'
import EntityMapPanel from './components/entity-map-panel/index.js'
import RelatedButton from './components/related-button/index.js'
import * as LeafletSleep from './components/map/leaflet.sleep'
import CommunityBlock from './components/community-block/communityBlock.js'

/**
 * Initialise site components and behaviours.
 */
PageReady.ready(() => {
  MobileMenu.init()
  ToTopButton.init()
  EmbeddedVideo.init()
  AutocompleteField.init()
  SearchField.init()
  LinkTile.init()
  Carousel.init()
  PopUp.init()
  Map.init()
  ShowMapButton.init()
  EntityMapPanel.init()
  RelatedButton.init()
  LeafletSleep
  CommunityBlock.init()
})
